import { type ObjectValuesUnionType } from '../../../utils/typing';

import { type MPFamilyId } from './families';

export const MPUserStatuses = Object.freeze({
  IN: 'IN', // Register in
  OFF: 'OFF', // Not registered
  EXCLUDED: 'EXCLUDED', // Excluded
});

export type MPUserStatus = ObjectValuesUnionType<typeof MPUserStatuses>;

export const MPNotificationsTypes = Object.freeze({
  CARD_WON: 'CARD_WON',
  FAMILY_COMPLETED: 'FAMILY_COMPLETED',
});

export type MPNotificationsType = ObjectValuesUnionType<typeof MPNotificationsTypes>;

export type MPUserNotification = {
  type: MPNotificationsType;
  uuid: string;
  data: {
    familyId: MPFamilyId;
    cardIndex?: number;
    totalAmount?: number;
  };
};
